import { createSlice } from '@reduxjs/toolkit';
import { 
    registerUser,
    signInUser,
    isAuth,
    signOut,
    getuserDetails,
    updateUserProfile,
    changeEmail,
    changePhNO,
    updateUserPsw
} from '../actions/users'

let DEFAULT_USER_STATE = {
    loading:false,
    data:{
      //  _id:null,
       // email:null,
       // firstname:null,
        //lastname:null,
        //age:null,
       // role:null,
        //verified:null
        id:null,
        name: null,
        username:null,
        email:null,
        password:null,
        phoneNo:null,
        designation:null,
        pincode:null,
        place:null,
        distcId:null,
        talukId:null,
        role:null,
        regnlID:null
    },
    auth:null
}

export const usersSlice = createSlice({
    name:'users',
    initialState:DEFAULT_USER_STATE,
    reducers:{

    },
    extraReducers:(builder)=>{
        builder
        // REGISTER
        .addCase(registerUser.pending,(state)=>{ state.loading = true })
        .addCase(registerUser.fulfilled,(state,action)=>{
            state.loading = false;
            state.data = action.payload.data;
            state.auth = action.payload.auth;
        })
        .addCase(registerUser.rejected,(state)=>{ state.loading = false })
        // SIGN IN
        .addCase(signInUser.pending,(state)=>{ state.loading = true })
        .addCase(signInUser.fulfilled,(state,action)=>{
            state.loading = false;
             //state.data = action.payload.data;
           ////console.log("&&&&&&&&&&&&&&&&&&")
           //console.log(action);

          
         // console.log(action.payload.data)
           //console.log(action.payload.data.username)
          // console.log("&&&&&&&&&&&&&&&&&&")
            state.data.id=action.payload.data.userId;
           state.data.username=action.payload.data.username;

           state.data.role = action.payload.data.roles[0].name ;

           
            //console.log(state.data.accessToken);
           // console.log("&&&&&&&&&&&&&&&&&&")




            state.auth = action.payload.auth;
        })
        .addCase(signInUser.rejected,(state)=>{ state.loading = false })
         // IS AUTH
         .addCase(isAuth.pending,(state)=>{ state.loading = true })
         .addCase(isAuth.fulfilled,(state,action)=>{
             state.loading = false;
            
             

            state.data = { ...state.data,...action.payload.data}

              state.auth = action.payload.auth;

           
 
         })
         .addCase(isAuth.rejected,(state)=>{ state.loading = false })
          // SIGN OUT
          .addCase(signOut.fulfilled,(state,action)=>{
            state.data = DEFAULT_USER_STATE.data
            state.auth = false;
        })
        //GET USER INFORMATIONS 
          /// UPDATE USER PROFILE
          .addCase(getuserDetails.fulfilled,(state,action)=>{
         
            state.data = {...state.data,...action.payload.data}

            console.log("1111111111111")
            console.log(state.data);
              console.log("222222222222")
           
        
         })

         /// UPDATE USER PROFILE
         .addCase(updateUserProfile.fulfilled,(state,action)=>{
         
          state.data = {...state.data,...action.payload.data}

       })
        /// CHANGE EMAIL
        .addCase(changeEmail.pending,(state)=>{ state.loading = true })
        .addCase(changeEmail.fulfilled,(state,action)=>{
            state.loading = false;
            state.data = { ...state.data,...action.payload}
        })
        .addCase(changeEmail.rejected,(state)=>{ state.loading = false })


         /// CHANGE MOBILE NUMBER 
         .addCase(changePhNO.pending,(state)=>{ state.loading = true })
         .addCase(changePhNO.fulfilled,(state,action)=>{
             state.loading = false;
             state.data = { ...state.data,...action.payload}
         })
         .addCase(changePhNO.rejected,(state)=>{ state.loading = false })
        /// UPDATE PASSWORD
        .addCase(updateUserPsw.fulfilled,(state,action)=>{
         
          state.data = {...state.data,...action.payload.data}

       })
        
    }
})

export default usersSlice.reducer